function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { PlaybackType } from '../../../core/player/playout-data';
import { ConvivaAddonLoader } from './conviva/conviva-addon-loader';
import { AdobeReportingAddonLoader } from './adobe/adobe-reporting-addon-loader';
import { ComscoreAddonLoader } from './comscore/comscore-addon-loader';
import { OpenMeasurementAddonLoader } from './open-measurement/open-measurement-addon-loader';
import { NielsenCloudAddonLoader } from './nielsen/nielsen-cloud-addon-loader';
import { NielsenSdkAddonLoader } from './nielsen/nielsen-sdk-addon-loader';
import { AgfNielsenBrowserSdkAddonLoader } from './agf-nielsen/agf-nielsen-browser-sdk-addon-loader';
import { VideoInitiate } from '../../addon-playout-data';
import { AdobeEdgeReportingAddonLoader } from './adobe-edge/adobe-edge-reporting-addon-loader';
import { sdkLogger } from '../../../logger';
export var loadReportingAddons = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(internalConfigPerPlaybackType, metaAdapterFactories, device, opts) {
        var reportingAddonLoaders;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    reportingAddonLoaders = [
                        new OpenMeasurementAddonLoader(device),
                        new AgfNielsenBrowserSdkAddonLoader(device)
                    ];
                    if (metaAdapterFactories.conviva) {
                        reportingAddonLoaders.push(new ConvivaAddonLoader(device, metaAdapterFactories.conviva));
                    }
                    if (metaAdapterFactories.adobe) {
                        reportingAddonLoaders.push(new AdobeReportingAddonLoader(device, metaAdapterFactories.adobe));
                    }
                    if (metaAdapterFactories.adobeEdge) {
                        reportingAddonLoaders.push(new AdobeEdgeReportingAddonLoader(device, metaAdapterFactories.adobeEdge));
                    }
                    if (metaAdapterFactories.comscore) {
                        reportingAddonLoaders.push(new ComscoreAddonLoader(device, metaAdapterFactories.comscore));
                    }
                    if (metaAdapterFactories.nielsen) {
                        reportingAddonLoaders.push(new NielsenCloudAddonLoader(device, metaAdapterFactories.nielsen));
                    }
                    if (metaAdapterFactories.nielsenSdk && (opts === null || opts === void 0 ? void 0 : opts.isNielsenDtvrRequired)) {
                        reportingAddonLoaders.push(new NielsenSdkAddonLoader(device, metaAdapterFactories.nielsenSdk));
                    }
                    return [
                        4,
                        Promise.all(reportingAddonLoaders.map(function(loader) {
                            return loader.load(internalConfigPerPlaybackType);
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        {
                            addonLoaders: reportingAddonLoaders,
                            addonFactories: reportingAddonLoaders.map(function(loader) {
                                return loader.create;
                            })
                        }
                    ];
            }
        });
    });
    return function loadReportingAddons(internalConfigPerPlaybackType, metaAdapterFactories, device, opts) {
        return _ref.apply(this, arguments);
    };
}();
var checkIfAutoPlayTrailer = function(sessionItem) {
    var _sessionItem_reporting;
    if (!sessionItem) {
        return false;
    }
    var isTrailer = sessionItem.type === PlaybackType.Preview;
    var videoInitiate = ((_sessionItem_reporting = sessionItem.reporting) === null || _sessionItem_reporting === void 0 ? void 0 : _sessionItem_reporting.videoInitiate) || sessionItem.videoInitiate;
    var isAutoplay = videoInitiate === VideoInitiate.Autoplay;
    return isTrailer && isAutoplay;
};
export var checkIfDisabledForAutoPlayTrailer = function(reportingAddonSessionData, addonName) {
    var _reportingAddonSessionData_reportingSessionConfig_disableAnalyticsForAutoPlayTrailers, _reportingAddonSessionData_reportingSessionConfig;
    var isAutoPlayTrailer = checkIfAutoPlayTrailer(reportingAddonSessionData.sessionItem);
    var disableAnalyticsForAutoPlayTrailers = (_reportingAddonSessionData_reportingSessionConfig = reportingAddonSessionData.reportingSessionConfig) === null || _reportingAddonSessionData_reportingSessionConfig === void 0 ? void 0 : (_reportingAddonSessionData_reportingSessionConfig_disableAnalyticsForAutoPlayTrailers = _reportingAddonSessionData_reportingSessionConfig.disableAnalyticsForAutoPlayTrailers) === null || _reportingAddonSessionData_reportingSessionConfig_disableAnalyticsForAutoPlayTrailers === void 0 ? void 0 : _reportingAddonSessionData_reportingSessionConfig_disableAnalyticsForAutoPlayTrailers[addonName];
    return isAutoPlayTrailer && Boolean(disableAnalyticsForAutoPlayTrailers);
};
export function isDisabledForNoConsent(requiresUserConsentToBeUsed, optedOutSdks, addon, loggerContext) {
    if (requiresUserConsentToBeUsed && optedOutSdks && optedOutSdks.includes(addon)) {
        sdkLogger.withContext(loggerContext).info('Disabled for no consent');
        return true;
    }
    return false;
}

//# sourceMappingURL=reporting-addon-loader.js.map